import React from 'react';

const weekdays = ['日', '一', '二', '三', '四', '五', '六'];

export const WeekdayHeader: React.FC = () => {
  return (
    <div className="grid grid-cols-7 gap-px mb-0 flex-shrink-0 border-b border-border/60 pb-2">
      {weekdays.map((day) => (
        <div
          key={day}
          className="text-center text-xs font-medium text-muted-foreground py-1"
        >
          {day}
        </div>
      ))}
    </div>
  );
};
